import React, { useState } from 'react';
import { CategoriesMenuButton, OffersSideMenu, BottomSheet } from '@desquared/wave-components-library';
import styles from './OffersCategoriesMenu.module.css';
import { useTranslations } from 'next-intl';

export default function OffersCategoriesMenu({ bundleCategories = [], onCategoriesClick, selectedCategory }) {
  const t = useTranslations('common.categories_menu');
  const [showMobile, setShowMobile] = useState(false);
  return (
    <>
      <div className={styles.mobileContainer}>
        <CategoriesMenuButton
          title={selectedCategory?.name || ''}
          onBack={() => {
            setShowMobile(true);
          }}
        />
        <BottomSheet open={showMobile} setOpen={setShowMobile} title={t('header')}>
          <OffersSideMenu
            title={t('offers_title')}
            onClick={id => {
              onCategoriesClick(id);
              setShowMobile(false);
            }}
            items={bundleCategories}
          />
        </BottomSheet>
      </div>
      <div className={styles.container}>
        <OffersSideMenu title={t('offers_title')} onClick={onCategoriesClick} items={bundleCategories} />
      </div>
    </>
  );
}
